export const TLRoles = [
  { id: "TEAM_LEADER", name: "Team Leader" },
  { id: "TEAM_MANAGER", name: "Team Manager" },
  {
    id: "SENIOR_TEAM_MANAGER",
    name: "Senior Team Manager",
  },
  { id: "GLOBAL_MANAGER", name: "Global Manager" },
];
